export const useABConfig = require('@/hooks/useABConfig').default
export const useApplication = require('@/hooks/useApplication').default
export const useBasket = require('@/hooks/useBasket').default
export const useBenefits = require('@/hooks/useBenefits').default
export const useBrowser = require('@/hooks/useBrowser').default
export const useCancellation = require('@/hooks/useCancellation').default
export const useCategories = require('@/hooks/useCategories').default
export const useChat = require('@/hooks/useChat').default
export const useCollective = require('@/hooks/useCollective').default
export const useCondition = require('@/hooks/useCondition').default
export const useConfirmation = require('@/hooks/useConfirmation').default
export const useContact = require('@/hooks/useContact').default
export const useContract = require('@/hooks/useContract').default
export const useDebouncedSaving = require('@/hooks/useDebouncedSaving').default
export const useDiffBasket = require('@/hooks/useDiffBasket').default
export const useDistribution = require('@/hooks/useDistribution').default
export const useDoctor = require('@/hooks/useDoctor').default
export const useDocument = require('@/hooks/useDocument').default
export const useError = require('@/hooks/useError').default
export const useExistingCustomer = require('@/hooks/useExistingCustomer').default
export const useFranchise = require('@/hooks/useFranchise').default
export const useIncentive = require('@/hooks/useIncentive').default
export const useLogger = require('@/hooks/useLogger').default
export const useMasterdata = require('@/hooks/useMasterdata').default
export const useNextSteps = require('@/hooks/useNextSteps').default
export const useNotifications = require('@/hooks/useNotifications').default
export const useOvp = require('@/hooks/useOvp').default
export const usePartner = require('@/hooks/usePartner').default
export const usePerson = require('@/hooks/usePerson').default
export const useProduct = require('@/hooks/useProduct').default
export const useProductState = require('@/hooks/useProductState').default
export const useQuiz = require('@/hooks/useQuiz').default
export const useResources = require('@/hooks/useResources').default
export const useSession = require('@/hooks/useSession').default
export const useStatus = require('@/hooks/useStatus').default
export const useSync = require('@/hooks/useSync').default
export const useSurvey = require('@/hooks/useSurvey').default
export const useTranslation = require('@/hooks/useTranslation').default
export const useUrl = require('@/hooks/useUrl').default
export const useValidation = require('@/hooks/useValidation').default
